export { default as SliderFavorites} from './slider'
